export const updateShippingValue = () => {
	if ($('#shipping-addr-same-as-billing-addr').prop("checked") == true) {
        $('input[name="shipping_state"]').val($('select[name="billing_state"]').val());
    } else {
        $('input[name="shipping_state"]').val($('select[name="shipping_state01"]').val());
    };
};
